import React from 'react'
import CarouselIndex from '../../components/Carousel'
import TitleRed from '../../components/TitleRed'
import Title from '../../components/Title'
import '../../css/DownloadCenter.scss'
import '../../css/MultiPlatform.scss'
import { Helmet } from 'react-helmet';


const Carousel_text = [
  {
    type:'multi_platform',
    carouselImage: "https://static.yiliit.com/qolai_cn/multi_platform_banner.png",
    text: [
      { text: "多终端合一，信息互联", colorText: "微信小程序/支付宝小程序/公众号H5", br: true },
      { text: "掘金", },
      { text: "", colorText: "腾讯系与阿里系" },
      { text: "巨量用户流量池，抢占时代红利" }
    ],
    textStyle: {
      textAlign: 'center',
    },
    background: '#4B588B',
    fontWeight:400,
    marginBottom:"20px",
  }
]

const scopeArr = [
  {
    img: 'multi-platform-moduleC1',
    title: '多个入口',
    title2: '搜索购买、视频购买、评论购买、企业主页、客户留存等多方入口，提升品牌曝光率'
  },
  {
    img: 'multi-platform-moduleC2',
    title: '一键宣传',
    title2: '小程序一键视频分享，随时随地打造营销广告'
  },
  {
    img: 'multi-platform-moduleC3',
    title: '海量用户',
    title2: '抓住10亿级抖音用户，搭建专属私域流量池，让粉丝成为你的专属用户，让粉丝成为你的专属用户'
  },
  {
    img: 'multi-platform-moduleC4',
    title: '视频推广',
    title2: '视频内可一键挂载小程序，用户可边刷视频，边快速下单'
  }
]

let pageTimer = '' //停留时间

class DispatchSystem extends React.Component {
  state = {

  };

  componentWillMount() {
    // 获取进入页面的时间
		if (pageTimer === '') {
			pageTimer = parseInt(new Date().getTime() / 1000);
			console.log(pageTimer,'pageTimer')
		}
    this.props.onVisitClick({
      type: 1,
      domain: 'www.qolai.cn',
      page: 'multi_platform'
    },0)
  }

  componentWillUnmount() {
    // 离开时间减去进入时间
    const tempTimer = parseInt(new Date().getTime() / 1000) - pageTimer;
    console.log(tempTimer,'tempTimer')
    // 清空时间戳
    pageTimer = '';
    if (tempTimer > 0) {
      this.props.onVisitClick({
        type: 2,
        domain: 'www.qolai.cn',
        page: 'multi_platform',
        time: tempTimer
      },0)
    }
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>抖音外卖-团购-趣来达</title>
          <meta name="Description" content="趣来达O2O本地平台系统，一次性接入字节旗下各个APP，以小程序为内容载体，利用字节跳动推荐算法与搜索能力把小程序准确推荐给用户，为本地生活业务提供高效的场景搭建和丰富的玩法，借力短视频与直播流量风口，为平台快速营销、宣传、裂变，累积更多用户。" />
          <meta name="Keywords" content="抖音外卖,抖音团购" />
        </Helmet>
        {/**顶部banner**/}
        <CarouselIndex data={Carousel_text} />

        <div className="d-flex justify-content-center" style={{background:'#F7F9FC'}}>
          <div className="download-center">
            <div className="download-center d-flex " style={{height:'600px',width:'1440px'}}>
              <img alt="" src="https://static.yiliit.com/qolai_cn/multi_platform/multi_platform_scene1.png" style={{width:'600px',height:'500px',marginRight:"153px"}}/>
              <div className="d-flex flex_column" style={{width:'658px'}}>
                <div style={{fontSize:'30px',fontWeight:'bold',marginBottom:'29px',color:'#121213'}}>
                  产品概述
                </div>
                <div style={{fontSize:'24px',fontWeight:'bold',color:'#121213',marginBottom:"15px"}}>
                  在中国，所有的生意都值得再做一次，
                </div>
                <div style={{fontSize:'24px',fontWeight:'bold',color:'#121213',marginBottom:"30px"}}>
                 尤其是在消费升级的时代。
                </div>
                <div style={{fontSize:'16px',lineHeight:'25px',color:'#707070'}}>
                  趣来达O2O本地平台系统，一次性接入微信小程序、支付宝小程序、H5，以小程序为内容载体，利用微信和支付宝推荐算法与搜索能力把小程序准确推荐给用户，为本地生活业务提供高效的场景搭建和丰富的玩法，借力社交与支付属性，为平台快速营销、宣传、裂变，累积更多用户。
                </div>
                
              </div>
            </div>
          </div>
        </div>

        {/* 为什么选择趣来达外卖系统 */}
        <div style={{ marginTop: '80px' }}>
          <TitleRed titleFront="入局"
            spanColor="本地生活市场"
            titleRear="，这块蛋糕有多大？"
            text="Tik Tok bazaar"
            width={710}
            height={66} />
          <div className="d-flex justify-content-center">
            <div className="d-flex flex_column align-cen jscen" style={{ width: '1440px' }}>
              <p style={{ fontSize: '24px', fontWeight: 'bold', color: ' #121213', marginBottom: '60px' }}>搭乘时代顺风车，紧握本地生活服务领域风口，瓜分本地生活市场</p>
              <div>
                <img alt="" src="https://static.yiliit.com/qolai_com/platform/plate4Image.png" style={{ width: '1440px', height: "720px", marginBottom: '20px' }} />
              </div>

            </div>
          </div>
        </div>

        {/* 为什么选择趣来达外卖系统 */}
        <div style={{ marginTop: '80px' }}>
        <Title
            title="趣来达，一套支持多平台运营的系统"
            text="multi-platform system"
            width={750}
            height={68}
          />
          <div className="d-flex justify-content-center">
            <div className="d-flex jscen">
              <div>
                <img alt="" src="https://static.yiliit.com/qolai_com/platform/product_image3.png" style={{ width: '100%',maxWidth:'1920px', height: "253px", marginBottom: '100px' }} />
              </div>

            </div>
          </div>
        </div>

      </div>
    )
  }
}

export default DispatchSystem;